import {
    CHANGE_COUNTRY_MENU,
    SET_PAYMENT_METHOD,
    SET_PRECHECK,
    UPDATE_CARD_FROM,
    UPDATE_CARD_TO,
    UPDATE_PAY_SOURCE,
    UPDATE_PAYMENT_FORM,
    UPDATE_SEND,
} from 'actions/sendAction';

import { clearGarbageDataForSendOrRequest } from 'helpers/clearData';

import update from 'immutability-helper';

const send = (state = {}, action) => {
    let mergeState;
    let send;
    switch (action.type) {
        case UPDATE_SEND:
            send = { ...action.send };
            clearGarbageDataForSendOrRequest(send);
            send = update(send, {
                paymentInfo: {
                    // account: {$merge: state.paymentInfo.account},
                    card: {
                        $auto: {
                            cardAlias: { $set: state.paymentInfo.card.cardAlias },
                            paymentSystem: { $set: state.paymentInfo.card.paymentSystem },
                            cardLogo: { $set: state.paymentInfo.card.cardLogo },
                        },
                    },
                },
            });
            mergeState = update(state, { $merge: send });
            break;
        case UPDATE_PAYMENT_FORM:
            mergeState = update(state, {
                paymentForm: { $merge: action.paymentForm },
            });
            break;
        case SET_PRECHECK:
            mergeState = update(state, {
                precheck: { $set: action.precheck },
            });
            break;
        case SET_PAYMENT_METHOD:
            mergeState = update(state, {
                paymentForm: {
                    paymentSourceFromMethod: { $set: action.method },
                },
            });
            break;
        case UPDATE_CARD_FROM:
            mergeState = update(state, {
                paymentInfo: {
                    card: {
                        cardAlias: { $set: action.alias },
                        code: { $set: action.code },
                        paymentSystem: { $set: action.paymentSystem },
                        cardLogo: { $set: action.cardLogo },
                        cvvFocus: { $set: action.cvvFocus },
                    },
                    sourceFrom: { $set: action.code },
                },
            });
            break;
        case UPDATE_CARD_TO:
            mergeState = update(state, {
                paymentInfo: {
                    cardTo: {
                        cardAlias: { $set: action.alias },
                        code: { $set: action.code },
                        paymentSystem: { $set: action.paymentSystem },
                        cardLogo: { $set: action.cardLogo },
                        cvvFocus: { $set: action.cvvFocus },
                    },
                },
            });
            break;
        case UPDATE_PAY_SOURCE:
            mergeState = update(state, {
                paySource: { $set: action.paySource },
            });
            break;
        case CHANGE_COUNTRY_MENU:
            send = { ...action.send };
            send = update(send, {
                countryMenu: { $set: action.countryMenu },
            });
            mergeState = update(state, { $merge: send });
            break;
        default:
            return state;
    }
    return mergeState;
};
export default send;
